<form role="form" class="form-horizontal">

	<div class="form-group row">
		<label class="control-label col-md-1">N° PA</label>
		<div class="col-md-3">
			<input id="numeroPa" type="text" placeholder="N° PA"
				class="form-control" [(ngModel)]="searchCriteria.numeroPa"
				(ngModelChange)="onNumeroPaChange()" />
		</div>
		<label class="col-md-1 control-label" for="perimetreReferent">Mon
			Périmètre Référent</label>
		<div class="col-md-3">
			<div class="checkbox">
				<label> <input type="checkbox" name="monPerimetreReferent" [disabled]="userRole !== 'CCE'"
					[(ngModel)]="searchCriteria.monPerimetreReferent"
					(ngModelChange)="onPerimetreReferentChange($event)" />
				</label>
			</div>
		</div>
	</div>
	<div class="form-group">
		<agence-filterable-selector [id]="'filtreAgence'"
			[labelClass]="'col-md-1'" [disabled]="userRole !== 'CCE'"
			[fieldClass]="'col-md-3'" [selectedAgenceId]="searchCriteria.agence"
			(selectedAgenceChange)="onAgenceChange($event)">
		</agence-filterable-selector>
		<antenne-filterable-selector [id]="'filtreAntenne'"
			[labelClass]="'col-md-1'" [disabled]="userRole !== 'CCE'"
			[fieldClass]="'col-md-3'" [agenceId]="searchCriteria.agence"
			[selectedAntenneId]="searchCriteria.antenne"
			(selectedAntenneChange)="onAntenneChange($event)">
		</antenne-filterable-selector>
	</div>

	<div class="form-group">
		<groupement-filterable-selector [id]="'filtreGroupement'"
			[labelClass]="'col-md-1'" [fieldClass]="'col-md-3'"
			[agenceId]="searchCriteria.agence"
			[antenneId]="searchCriteria.antenne"
			[selectedGroupementId]="searchCriteria.groupement"
			(selectedGroupementChange)="onGroupementChange($event)">
		</groupement-filterable-selector>
		<parc-filterable-selector [id]="'filtreParc'"
			[labelClass]="'col-md-1'" [fieldClass]="'col-md-3'"
			[agenceId]="searchCriteria.agence"
			[antenneId]="searchCriteria.antenne"
			[groupementId]="searchCriteria.groupement"
			[selectedParcId]="searchCriteria.parc"
			(selectedParcChange)="onParcChange($event)">
		</parc-filterable-selector>
	</div>
	<div class="form-group">
		<label class="col-md-1 control-label" for="entreprise">Entreprise</label>
		<div class="col-md-3">
			<no-input-reset-filterable-select [inputClass]="'form-control'"
				[list]="entreprises" [resetCommand]="resetCommands"
				[labelGetter]="getEntrepriseName"
				(selectedItemChange)="onEntrepriseSelected($event)">
			</no-input-reset-filterable-select>
		</div>
	</div>

	<div class="form-group">
		<label class="col-md-1 control-label" for="entreprise">Sur
			site / A distance</label>
		<div class="col-md-3">
			<checkbox-list [id]="'choixTypePdp'" [wildcardOptionLabel]="'Tous'"
				[itemList]="typePaOptions" [labelGetter]="getTypePaLabel"
				[preselectionFunction]="typePaShouldBeSelectedByDefaut"
				[resetCommands]="resetCommands"
				(selectedItemsChange)="onTypePaSelected($event)"> 
			</checkbox-list>
		</div>
		<label class="col-md-1 control-label" for="entreprise">Etat</label>
		<div class="col-md-3">
			<checkbox-list [id]="'choixEtat'" [wildcardOptionLabel]="'Tous'"
				[itemList]="etatDocumentPa" [labelGetter]="getEtatLabel"
				[preselectionFunction]="etatPaShouldBeSelectedByDefaut"
				[resetCommands]="resetCommands"
				(selectedItemsChange)="onEtatPaSelected($event)"> 
			</checkbox-list>
		</div>
		<label class="col-md-1 control-label" for="entreprise">Validité</label>
		<div class="col-md-3">
			<checkbox-list [id]="'choixTypePdp'" [wildcardOptionLabel]="'Tous'"
				[itemList]="validiteOptions" [labelGetter]="getValiditeLabel"
				[preselectionFunction]="validitePaShouldBeSelectedByDefaut"
				[resetCommands]="resetCommands"
				(selectedItemsChange)="onValiditePaSelected($event)">
			</checkbox-list>
		</div>
	</div>

	<div class="form-group">
		<div class="col-sm-2 text-center">
			<button type="button" class="btn btn-primary"
				(click)="resetFilters()">Réinitialiser</button>
		</div>
	</div>
</form>
